import { cn } from "@ui/lib/utils";

const CHECKERBOARD_STYLE: React.CSSProperties = {
  backgroundColor: "#fff",
  backgroundImage:
    "linear-gradient(45deg, #e0e0e0 25%, transparent 25%), linear-gradient(-45deg, #e0e0e0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e0e0e0 75%), linear-gradient(-45deg, transparent 75%, #e0e0e0 75%)",
  backgroundSize: "20px 20px",
  backgroundPosition: "0 0, 0 10px, 10px -10px, -10px 0",
};

/**
 * Renders a checkerboard pattern typically used to indicate image transparency.
 */
export function TransparencyCheckerboard({ className }: { className?: string }) {
  return <div className={cn("tw-absolute tw-inset-0", className)} style={CHECKERBOARD_STYLE} />;
}
